import { gql } from '@apollo/client';
import { WarrantyIssueInfo } from '../fragments';

export default gql`
  query warrantyIssue($id: ID) {
    warrantyIssue(id: $id) {
      ...WarrantyIssueInfo
    }
  }
  ${WarrantyIssueInfo}
`;
